module.exports = __webpack_public_path__ + "media/Images/DotYellow-f82cd0f1.svg";